import React from 'react';
import './AdditionalProgramsSupportMessage.css';

const AdditionalProgramsSupportMessage = () => (
    <aside
        className="additionalProgramsSupportMessage"
        aria-label="Program support"
    >
        <p className="additionalProgramsSupportMessage__text">
            If you purchased a program and don&apos;t see it here, USANA
            Customer Service is here to help.
        </p>
        <p className="additionalProgramsSupportMessage__hours">
            <strong>Monday–Friday: 8 a.m. to 5 p.m. MST</strong>
        </p>
        <p className="additionalProgramsSupportMessage__contact">
            <a href="tel:1-888-950-9595">1-888-950-9595</a>
            {' or '}
            <a href="mailto:customerservice@usanainc.com">
                customerservice@usanainc.com
            </a>
        </p>
    </aside>
);

export default AdditionalProgramsSupportMessage;
